export default __webpack_public_path__ + "static/media/snowuns-mobile-merch.46f87809.webp";